import {Chip, Stack, useTheme} from "@mui/material";
import {useState} from "react";
import {Link} from "react-scroll";
import ScrollAnimation from 'react-animate-on-scroll';

const CategoriesList = (props) => {
    const theme = useTheme();
    const [selected, setSelected] = useState((props.data.length > 0) ? props.data[0].id : 0);

    const onCategoryClick = (cId) => {
        setSelected(cId);
        props.onCategorySelected(cId);
    }

    const handleSetActive = (cId) => {
        setSelected(cId);
    }

    const categories = props.data.map((cat,index) => {
        return <Link
            smooth={true}
            key={`catChip-${cat.id}`}
            offset={-158}
            spy={true}
            onSetActive={() => handleSetActive(cat.id)}
            to={`cat-${cat.id}`}>
            <ScrollAnimation animateIn='zoomIn' offset={50} delay={50 * index}>
                <Chip
                    color={selected === cat.id ? 'brAccent' : 'secondary'}
                    label={cat.name}
                    onClick={() => onCategoryClick(cat.id)}
                    sx={{
                        backgroundColor: (selected === cat.id) ? theme.palette.brAccent.main : theme.palette.secondary.main
                    }}
                />
            </ScrollAnimation>
        </Link>
    })
    return <>
        <Stack
            direction='row'
            flexWrap='wrap'
            spacing={1}
            rowGap={1}
            alignItems='center'
            justifyContent='center'
            sx={{
                my: 1,
            }}
        >
            {categories}
        </Stack>
    </>
}

export default CategoriesList;